import React from 'react';

const About = () => {
  return (
<div className="section">
      <h2>About Us</h2>
      <p>
        Welcome to <strong>Rhodiumroot.com</strong>.  Rhodium Root was put together to help me track and improve my health.  
        It is unbiased and not influenced by outside money helping people make informed decisions that are not influenced by brands or my own products.
        The mission is to empower individuals with the tools, insights, and information that I use to improve my own health.
      </p>
      <h3>Who am I?</h3>
      <p>
      With over 25 years of experience in cybersecurity, I’ve built a career specializing in risk management, offensive security, network security, data forensics, and more. In recent years, my focus has expanded to include exploring AI solutions in-depth, uncovering their potential to revolutionize industries—including healthcare.
      </p>
      <p>
      After facing several health challenges, I decided to take a proactive approach to my well-being. Recognizing the limitations of traditional systems, I’ve embraced the power of data-driven insights and biohacking to improve my health and longevity. By combining my expertise in risk analysis and cutting-edge AI, I’m committed to optimizing my well-being and inspiring others to take control of their health journeys.
      </p>
      <h3>Our Vision</h3>
      <p>
        At Rhodiumroot, we are committed to a root-level approach to optimization. From exploring and tracking an individuals improvement in health including nutrition and fitness to advanced wellness strategies, all with the goal of achieving root-level transformation without any financial outside influence.
        This journey revolves around six core focuses: Research, Exercise, Nutrition, Testing, Recovery, and Discipline—each a pillar in the quest for peak performance and long-term vitality.
      </p>
      <h3>Contact Us</h3>
      <p>
       If you have any questions about these Terms and Conditions, please contact us at: support@rhodiumroot.com
      </p>
    </div>
  );
};

export default About;
